import { html } from "lit-html";

import { appendRequiredAsterisk } from "../sc-e-form-field/sc-e-form-field.template";
import { FormFieldGroupLegendRenderArgs } from "./sc-m-form-field-group.types";

export const getLegend = (args: FormFieldGroupLegendRenderArgs) => {
  if (args.legend === "") return "";
  return html`
    <legend class="sc-m-form-field-group__legend">${appendRequiredAsterisk(args.legend, args.isRequired)}</legend>
  `;
};
